<template>
    <div class="at_list" :class="{ android: android }">
        <title-bar class="at_bar" type="back" :back-cb="cancel" title="选择要@的人"></title-bar>
        <ul>
            <v-touch @tap="chooseAt(item)" v-for="(item, index) in list" :key="index">
                <li>
                    <avatar
                        class="at_avatar"
                        :avatar-url="item.avatar"
                        :textAvatar="$root.remark.getRemarkName(item.id, item.username).slice(-1)"
                        :color="item.color"
                    ></avatar>
                    <div class="name">{{ $root.remark.getRemarkName(item.id, item.username) }}</div>
                </li>
            </v-touch>
        </ul>
    </div>
</template>

<script>
import titleBar from "@/components/layout/TitleBar"
import avatar from "@/components/common/Avatar"
export default {
    components: {
        avatar,
        titleBar
    },
    data() {
        return {
            list: []
        }
    },
    computed: {
        android() {
            return window.system === "android"
        }
    },
    mounted() {
        this.getUsername()
    },
    methods: {
        async getUsername() {
            let projectId = this.$route.query.project_id
            let res = await API.project.getProjectUsernames(projectId)
            if (res) {
                let data = res.data
                data.result.forEach(item => {
                    item.username = item.username
                })
                this.list = data.result
            }
        },
        chooseAt(item) {
            this.$emit("selected", this.$root.remark.getRemarkName(item.id, item.username))
        },
        cancel() {
            this.$emit("selected", "")
        }
    }
}
</script>

<style lang="scss" scoped>
.at_list {
    &.android {
        padding-top: 3.45rem;
    }
    height: 100%;
    padding-top: 3.35rem; //ios_top
    padding-top: calc(constant(safe-area-inset-top) + 2.35rem);
    padding-top: calc(env(safe-area-inset-top) + 2.35rem);
    box-sizing: border-box;
    .at_bar {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1111;
    }

    ul {
        height: 100%;
        overflow-y: auto;
        background: white;
        li {
            height: 2.25rem;
            padding-left: 0.75rem;
            box-sizing: border-box;
            .at_avatar {
                margin-top: 0.21rem;
                width: 1.83rem;
                height: 1.83rem;
                font-size: 0.9rem;
                float: left;
                margin-right: 0.5rem;
            }
            .name {
                width: calc(100% - 2.54rem);
                float: left;
                font-size: 0.7rem;
                line-height: 2.25rem;
                border-bottom: 1px solid RGBA(201, 201, 201, 0.2);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}
</style>
